<template>
  <div class="sp_changePassword">
    <el-dialog :title="passwordMsg.title"
               :visible="passwordMsg.show"
               width="640px"
               :before-close="handleClose"
               :close-on-click-modal="false">
      <el-form :model="passwordForm"
               class="creat-user-form"
               ref="passwordForm"
               :rules="passwordRules">

        <el-form-item class="item"
                      label="New Password："
                      prop="newPassword">
          <el-input autocomplete="new-password"
                    :type="newPassType"
                    v-model.trim="passwordForm.newPassword"
                    size="medium"
                    placeholder="Please input password.">
            <svg-icon :icon-class="newPassType == 'password' ? 'hide' : 'view'"
                      slot="suffix"
                      @click.native="newPassView"></svg-icon>
          </el-input>
        </el-form-item>

        <el-form-item class="item"
                      label="Enter the password again："
                      prop="confirmPassword">
          <el-input autocomplete="new-password"
                    :type="confirmPassType"
                    v-model.trim="passwordForm.confirmPassword"
                    size="medium"
                    placeholder="Please confirm the password again.">
            <svg-icon :icon-class="confirmPassType == 'password' ? 'hide' : 'view'"
                      slot="suffix"
                      @click.native="confirmPassView"></svg-icon>
          </el-input>
        </el-form-item>

      </el-form>
      <span slot="footer"
            class="dialog-footer">

        <el-button class="btn"
                   type="primary"
                   @click="changePassword('passwordForm')"
                   size="medium">OK</el-button>
        <el-button class="btn"
                   @click="handleClose"
                   size="medium">Cancel </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updatePasswordApi } from '@/api/userApi.js'
import { registerEncrypt } from '@/utils/encrypt.js'
export default {
  name: 'changePassword',
  props: {
    passwordMsg: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    var checkNewPassword = (rule, value, callback) => {
      const Reg = /^(?!.*\s)(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\W_]).{8,16}$/
      if (!value) {
        return callback(new Error('Please input the new password.'))
      } else {
        if (Reg.test(value)) {
          if (this.passwordForm.confirmPassword) {
            if (
              this.passwordForm.newPassword ===
              this.passwordForm.confirmPassword
            ) {
              const _this = this
              _this.$refs.passwordForm.clearValidate('confirmPassword')
              return callback()
            } else {
              return callback(
                "Those passwords didn't match. Try again."
              )
            }
          } else {
            return callback()
          }
        } else {
          return callback(
            new Error(
              'Use 8 to 16 characters with a mix of letters, numbers & symbols.'
            )
          )
        }
      }
    }
    var checkConfirmPas = (rule, value, callback) => {
      const Reg = /^(?!.*\s)(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\W_]).{8,16}$/
      if (!value) {
        return callback(new Error('Please confirm the password again.'))
      } else {
        if (Reg.test(value)) {
          if (this.passwordForm.confirmPassword) {
            if (this.passwordForm.newPassword ===
              this.passwordForm.confirmPassword) {
              const _this = this
              _this.$refs.passwordForm.clearValidate('password')
              return callback()
            } else {
              return callback("Those passwords didn't match. Try again.")
            }
          } else {
            return callback()
          }
        } else {
          return callback(new Error("Use 8 to 16 characters with a mix of letters, numbers & symbols."))
        }
      }
    }
    return {
      passwordForm: {
        newPassword: '',
        confirmPassword: '',
      },
      newPassType: 'password',
      confirmPassType: 'password',
      passwordRules: {
        newPassword: [
          { required: true, validator: checkNewPassword, trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, validator: checkConfirmPas, trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    //切换密码框密码显示隐藏
    newPassView() {
      this.newPassType = this.newPassType == 'password' ? 'text' : 'password'
    },
    confirmPassView() {
      this.confirmPassType =
        this.confirmPassType == 'password' ? 'text' : 'password'
    },

    //修改密码
    changePassword(passwordForm) {
      this.$refs[passwordForm].validate((valid) => {
        if (valid) {
          let params = {
            id: this.passwordMsg.row.id,
            password: registerEncrypt(
              JSON.parse(JSON.stringify(this.passwordForm.confirmPassword))
            ),
          }

          this.$confirm(
            'Are you sure you want to change your password?',
            'hint',
            {
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              type: 'warning',
              beforeClose: (action, instance, done) => {
                if (action === 'confirm') {
                  instance.confirmButtonLoading = true
                  updatePasswordApi(params)
                    .then((res) => {
                      instance.confirmButtonLoading = false
                      done()
                    })
                    .catch(() => {
                      instance.confirmButtonLoading = false
                    })
                } else {
                  done()
                }
              },
            }
          )
            .then(() => {
              if (
                this.passwordMsg.row.id == this.$store.state.user.userInfo.id
              ) {
                this.$message({
                  type: 'success',
                  message: 'Save successfully. Please log in again.',
                })
                setTimeout(() => {
                  this.$store.dispatch('LogOut')
                }, 1000)
              } else {
                this.$message({
                  type: 'success',
                  message: 'Save successfully.',
                })
                this.$emit('passwordChildMsg', { show: false, isSave: true })
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      })
    },

    handleClose() {
      this.$emit('passwordChildMsg', { show: false, isSave: false })
    },
  },

  created() {},
}
</script>

<style scoped lang="scss">
.creat-user-form {
  padding: 16px 20px 4px 20px;
  .el-form-item {
    margin-bottom: 16px;
  }
  .flex-item {
    width: 560px;
  }
}
.btn {
  width: 64px;
}
/deep/.el-dialog__body {
  padding: 0 20px;
}

/deep/.el-form-item__label {
  height: 20px;
  line-height: 20px;
  margin-bottom: 4px;
  font-size: 14px;
  color: #545c66;
}

/deep/.el-form-item__content {
  line-height: 32px;
  width: 560px;
}
</style>